import React from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const CardInternship = ({
  id,
  cardActive,
  label,
  value,
  callbackFn,
  setcardActive,
  setTextActive,
}) => {
  return (
    <Card
      sx={{
        width: "180px",
        cursor: "pointer",
        backgroundColor: id === cardActive ? "rgba(24,118,209,0.3)" : "",
      }}
      onClick={() => {
        callbackFn();
        setcardActive(id);
        setTextActive(label);
      }}
    >
      <CardContent>
        <Typography variant="body2" sx={{
           fontWeight: "bold"
         }}>{label}</Typography>

        <Typography variant="h5" component="div" sx={{
          color: id === cardActive ? "rgba(24,118,209,1)" : "", fontWeight: "bold", fontSize: "1.7rem"
        }}>
          {value}
        </Typography>
      </CardContent>
      {/* <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
  );
};

export default CardInternship;
